import React from "react";

const TERMS = "https://piosolver.com/docs/licensing";

function SellerNotice() {
  return (
    <p className="text-muted small mt-4 mb-2">
      Sold by PIOSOFTWARE LTD, Archiepiskopou Makariou III, 53, C BREEZE
      RESIDENCE, 1st floor, Flat/Office 1, Meneou, 7000, Larnaca, Cyprus. VAT
      CY60140709L. HE 471080, Department of Registrar of Companies and
      Intellectual Property, Cyprus. Email <i>support@piosolver.com</i>. Phone
      +357 97472109.{" "}
      <a href={TERMS}>Terms</a>
      {" · "}
      <a href={`${TERMS}#privacy-policy`}>Privacy</a>
      {" · "}
      <a href={`${TERMS}#refund-policy`}>Refunds</a>.
    </p>
  );
}

export default SellerNotice;
